import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
} from '@fluentui/react-components';
import { DismissRegular, CalendarRegular } from '@fluentui/react-icons';

interface FollowedUpDialogProps {
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (data: { date: string; text: string }) => void;
  initialData?: { date: string; text: string };
}

export const FollowedUpDialog: React.FC<FollowedUpDialogProps> = ({
  isOpen,
  onDismiss,
  onSave,
  initialData,
}) => {
  const [date, setDate] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    if (initialData) {
      setDate(initialData.date || '');
      setText(initialData.text || '');
    }
  }, [initialData]);

  const handleSave = () => {
    onSave({ date, text });
  };

  const handleDateAdd = (selectedDate: string) => {
    if (date.length < 1) {
      setDate(`${selectedDate} `);
    } else {
      setDate(`${date.trim()}, ${selectedDate}`);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onDismiss()}>
      <DialogSurface className="max-w-lg">
        <DialogBody>
          <div className="flex justify-between items-center mb-4">
            <DialogTitle>Uppföljd</DialogTitle>
            <Button
              appearance="subtle"
              icon={<DismissRegular />}
              onClick={onDismiss}
              aria-label="Close"
            />
          </div>
          <DialogContent>
            <div className="space-y-4">
              <div>
                <h5 className="text-base font-medium mb-2">Lägg till datum</h5>
                <Input
                  type="date"
                  className="w-full"
                  onChange={(_, data) => handleDateAdd(data.value)}
                  contentBefore={<CalendarRegular />}
                />
              </div>
              <div>
                <h5 className="text-base font-medium mb-2">Datum</h5>
                <Input
                  className="w-full"
                  value={date}
                  onChange={(_, data) => setDate(data.value)}
                />
              </div>
              <div>
                <h5 className="text-base font-medium mb-2">Text</h5>
                <Input
                  className="w-full"
                  value={text}
                  onChange={(_, data) => setText(data.value)}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions className="flex justify-end gap-2 mt-4">
            <Button appearance="primary" onClick={handleSave}>
              OK
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
